import React from 'react';
import dateFormat from 'dateformat';
import { isThisYear } from 'date-fns';
import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { getDateTimeFormat } from '#helper';

const DateWrapper = styled('div')(({ theme }) => ({
  width: 150,
  [theme.breakpoints.up('FWXGA')]: {
    width: 180
  },
  [theme.breakpoints.down('md')]: {
    width: 150
  }
}));

const Address = styled(Typography)({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: 14
});

export default props => {
  const { account } = props;
  if (!props.date && !props.destination) {
    return <DateWrapper />;
  }
  const date = props.date ?
    dateFormat(
      props.date,
      getDateTimeFormat(account && account.measurementSystem, isThisYear(new Date(props.date)) ? 'dateTime' : 'dateShort')
    ) : undefined;
  return (
    <DateWrapper title={props.origin || props.destination}>
      <div>{date && date.slice(0, 11)}</div>
      <Address color="textSecondary">
        {props.origin || props.destination}
      </Address>
    </DateWrapper>
  );
};
